import React from 'react';

const Header = () => (
    <div className="header">
        <div className="header__label">
            <span>mindnektar</span>&apos;s Game Tracker
        </div>
    </div>
);

export default Header;
